import {Injectable} from '@angular/core';
import {HttpClient, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {switchMap} from 'rxjs/operators';

@Injectable()
export class PosTokenInterceptor implements HttpInterceptor {
  private token$: Observable<any> | null = null;

  constructor(private readonly http: HttpClient) {}

  private getToken(): Observable<any> {
    if (!this.token$) {
      this.token$ = this.http.get(
        `${environment.apiResourceUri}/pos-integrity/token`,
      );
    }
    return this.token$;
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!req.url.startsWith(environment.ag2goApiResourceUri)) {
      return next.handle(req);
    }

    return this.getToken().pipe(
      switchMap(token => {
        const authReq = req.clone({
          setHeaders: { 'Authorization': `Bearer ${token.token}` }
        });
        return next.handle(authReq);
      })
    );
  }
}
